@if(innerWidth > 991.98){
<div class="webTable">
    <antim-autoware-card>
        @if(arrayValid){
        <div class="toolbarForTable">
            <div class="buttonAndLabel">
                <label class="form-label fs-6 fw-bold text-gray-900" [ngClass]="{'d-none': tableTitle.length === 0}">
                    {{tableTitle}}
                </label>
                <div appClickedOutside (clickedOutside)="clickedOutside()">
                    @if (columnsShow) {
                    <antim-autoware-button leftIcon="view_column" type="button" label="Columns" btnType="primary"
                        (clickEvent)='hideShowColumn()'></antim-autoware-button>
                    }
                    @if(filterShow){
                    <antim-autoware-button leftIcon="filter_alt" type="button" label="Filters" btnType="primary"
                        (clickEvent)='hideShowFilter()'></antim-autoware-button>
                    }
                    @if(sortShow){
                    <antim-autoware-button leftIcon="swap_vert" type="button" label="Sort" btnType="primary"
                        (clickEvent)='hideShowSort()'></antim-autoware-button>
                    }
                    @if(exportShow){
                    <antim-autoware-button leftIcon="download" type="button" label="Export" btnType="primary"
                        (clickEvent)='download()'></antim-autoware-button>
                    }

                    <span class="popup">
                        <span class="popuptext" [ngClass]="{'show': columnsPopupHideShow}">
                            <div class="popup-container">
                                @for (columnsOptionsItem of columnsOptions; track columnsOptionsItem;let i = $index) {
                                <antim-autoware-checkbox [id]="columnsOptionsItem.headerName"
                                    [label]="columnsOptionsItem.headerName" [isChecked]="columnsOptionsItem.display"
                                    (onInputChangeEvent)="columnsHideShow(i)" />
                                }
                            </div>
                            <button class="reset" [ngClass]="{'disabled': displayColumns.length === columns.length}"
                                [disabled]="displayColumns.length === columns.length" (click)="resetColumn()">
                                Reset
                            </button>
                        </span>
                        <span class="popuptext" [ngClass]="{'show': filterPopupHideShow}">
                            <div class="popup-container">
                                <form class="validate-form" [formGroup]="filterForm">
                                    <antim-autoware-select id="columns" name="columns" inputType="primary"
                                        [control]="filterFormControls.columns" labelValue="Columns"
                                        [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                        placeholder="Please select filter field" labelFieldName="label"
                                        valueFieldName="value" [data]="filterOptions">
                                    </antim-autoware-select>

                                    <antim-autoware-select id="operator" name="operator" inputType="primary"
                                        [control]="filterFormControls.operator" labelValue="Operator"
                                        [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                        placeholder="Please select operator" labelFieldName="title"
                                        valueFieldName="value" [data]="operatorOptionsList">
                                    </antim-autoware-select>

                                    <antim-autoware-input [control]="filterFormControls.filterValue" type="text"
                                        id="filterValue" name="filterValue" labelValue="Filter Value"
                                        placeholder="Search"></antim-autoware-input>
                                </form>
                            </div>
                            <button class="reset" (click)="resetFilter()">
                                Reset
                            </button>
                        </span>
                        <span class="popuptext" [ngClass]="{'show': sortPopupHideShow}">
                            <div class="popup-container">
                                <form class="validate-form" [formGroup]="sortForm">
                                    <antim-autoware-select id="columns" name="columns" inputType="primary"
                                        [control]="sortFormControls.columns" labelValue="Columns"
                                        [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                        placeholder="Please select sorting field" labelFieldName="label"
                                        valueFieldName="value" [data]="sortByOptions">
                                    </antim-autoware-select>

                                    <antim-autoware-select id="orderType" name="orderType" inputType="primary"
                                        [control]="sortFormControls.orderType" labelValue="Order Type"
                                        [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                        placeholder="Please select order type" labelFieldName="title"
                                        valueFieldName="value" [data]="sortOptionsList">
                                    </antim-autoware-select>
                                </form>
                            </div>
                            <button class="reset" (click)="resetSort()">
                                Reset
                            </button>
                        </span>
                    </span>
                </div>
            </div>
            <div>
                <input type="search" name="search" placeholder="Search" class="form-control search search-control"
                    (input)="search($event)" />
            </div>
        </div>
        <!-- table-view -->
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        @for (displayColumnsItem of displayColumns; track displayColumnsItem; let i = $index) {
                        <th (click)="updateSort(i)" class="{{displayColumnsItem.class}}"
                            [ngStyle]="{'min-width': displayColumnsItem.headerName === 'Action' ? ((displayColumnsItem.list.length * 32) + 24) +'px': displayColumnsItem.headerName === 'Status' ? '94px' : 'auto'}">
                            <span class="head-view">
                                <span [ngClass]="{'header': displayColumnsItem.sortable}">
                                    {{displayColumnsItem.headerName}}
                                </span>
                                @if (displayColumnsItem.sortable && checkSort(displayColumnsItem.field, "Ascending")) {
                                <i class="fa-solid fa-arrow-up-wide-short"></i>
                                }
                                @else if(displayColumnsItem.sortable && checkSort(displayColumnsItem.field,
                                "Descending")){
                                <i class="fa-solid fa-arrow-down-short-wide"></i>
                                }
                                @else if(displayColumnsItem.sortable && checkNonSort(displayColumnsItem.field)){
                                <i class="fa-solid fa-arrow-up-wide-short showOnHover"></i>
                                }
                            </span>
                        </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (currentRecordsItem of currentRecords; track currentRecordsItem;let index = $index) {
                    <tr>
                        @for (displayColumnsItem of displayColumns; track displayColumnsItem) {
                        <td class="{{displayColumnsItem.class}}"
                            (click)="displayColumnsItem.field !== 'action' ? action(index, 'fa-solid fa-pen-to-square') : ''">
                            @if (displayColumnsItem.field !== 'action' && displayColumnsItem.field !== 'isActive' &&
                            displayColumnsItem.field !== 'is_verified'){
                            @if (displayColumnsItem.type === 'radio'){
                            <antim-autoware-radio [data]="itemValueForRadio(currentRecordsItem, displayColumnsItem)"
                                [marginBottomZero]="true"
                                (onRadioChangeEvent)="onRadioChange(index, displayColumnsItem.field)" />
                            }
                            @else if (displayColumnsItem.type === 'checkbox'){
                            <antim-autoware-checkbox [id]="index.toString()" [marginBottomZero]="true"
                                [isChecked]="itemValueForCheckbox(currentRecordsItem, displayColumnsItem)"
                                (onInputChangeEvent)="onCheckBoxChange(index, displayColumnsItem.field)" />
                            }
                            @else if (displayColumnsItem.type === 'image'){
                            <img [src]="itemValue(currentRecordsItem, displayColumnsItem, index)"
                                (error)="errorHandler($event)" />
                            }
                            @else if (displayColumnsItem.type === 'coverFile'){
                            <i class="fa-solid fa-file" (click)="file(index,'coverFile')"></i>
                            }
                            @else if (displayColumnsItem.type === 'resumeFile'){
                            <i class="fa-solid fa-file" (click)="file(index,'resumeFile')"></i>
                            }
                            @else if (displayColumnsItem.type === 'Select'){
                            <antim-autoware-select inputType="primary" [labelHide]="true" labelFieldName="label"
                                [value]="itemValue(currentRecordsItem, displayColumnsItem, index)"
                                valueFieldName="value" [data]="displayColumnsItem.data"
                                (change)="onSelectChange(index, $event)" />
                            }
                            @else if (displayColumnsItem.isTrueFalse){
                            <span
                                [ngClass]="{'active-status-mobile': currentRecordsItem[displayColumnsItem.field] === 1,
                                            'de-active-status-mobile': currentRecordsItem[displayColumnsItem.field] === 0}">
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                            }
                            @else if(displayColumnsItem.type === 'date') {
                            {{dateTransformService.transFormDateWithoutTimeZone(currentRecordsItem[displayColumnsItem.field])}}
                            }
                            @else if(displayColumnsItem.type === 'dateTime') {
                            {{dateTransformService.transFormDate(currentRecordsItem[displayColumnsItem.field])}}
                            }
                            @else if (displayColumnsItem.isHTML) {
                            <div [innerHTML]="itemValue(currentRecordsItem, displayColumnsItem, index)"></div>
                            }
                            @else {
                            <span>{{itemValue(currentRecordsItem, displayColumnsItem, index)}}</span>
                            }
                            @if (displayColumnsItem.type === 'cleaner'){
                            <antim-autoware-select inputType="primary" [labelHide]="true" labelFieldName="label"
                                [value]="itemValue(currentRecordsItem, displayColumnsItem, index)"
                                valueFieldName="value" [data]="displayColumnsItem.data"
                                (change)="onCleanerChange(index, $event)" />
                            }
                            }
                            @else if(displayColumnsItem.field === 'is_verified'){
                            <span [ngClass]="
                                            {'pending-status': currentRecordsItem[displayColumnsItem.field] === 0,
                                            'active-status': currentRecordsItem[displayColumnsItem.field] === 1,
                                            'cancel-status': currentRecordsItem[displayColumnsItem.field] === 2}">
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                            }
                            @else if (displayColumnsItem.field == 'isActive'){
                            <span
                                [ngClass]="{ 'active-status': currentRecordsItem[displayColumnsItem.field] === true, 'de-active-status': currentRecordsItem[displayColumnsItem.field] === false }">
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                            }
                            @else if (displayColumnsItem.field == 'action') {
                            <span>
                                @for (listItem of displayColumnsItem.list; track listItem) {
                                @if(listItem.conditionField === undefined ||
                                (
                                listItem.conditionField !== undefined &&
                                itemValueConditionCheck(currentRecordsItem,listItem)
                                )){
                                <i class="fa" [ngClass]="actionIcon(index, listItem.action)"
                                    (click)="action(index, listItem.action)"
                                    [title]="actionTitle(index, listItem.action, listItem.title)"></i>
                                }
                                }
                            </span>
                            }
                        </td>
                        }
                    </tr>
                    }
                    @if (currentRecords.length === 0){
                    <tr>
                        <td [attr.colspan]="displayColumns.length" class="no-data-found">
                            No Data Found
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        @if(paging){
        <div class="pagination">
            <div>
                Rows per page:
                <antim-autoware-select id="select" name="select" inputType="primary" [control]="pageSizeFormControl"
                    [mainElementStyle]="{margin: '0px !important'}" [selectStyle]="{padding: '6px',marginLeft: '6px'}"
                    placeholder="Please select page size" labelFieldName="title" valueFieldName="value"
                    [data]="pageSizeList">
                </antim-autoware-select>
                <span class="details">
                    {{startFrom}} - {{endTo}} of {{totalRecord}}
                </span>
            </div>

            @if (!(currentPage == totalPages && currentPage == 1)){
            <div>
                <span class="prevNext" (click)="onPageChange(1, 'prev')">
                    <i class="fa-solid fa-chevron-left" [ngClass]="{'disabled': currentPage === 1}"></i>
                </span>
                <span class="prevNext" (click)="onPageChange(1, 'next')">
                    <i class="fa-solid fa-chevron-right" [ngClass]="{'disabled': currentPage === totalPages}"></i>
                </span>
            </div>
            }
        </div>
        }
        }
        @else {
        <div class="no-data-found">Radio and checkbox column needed unique column name</div>
        }

    </antim-autoware-card>
</div>
}
@else {
<div class="mobileTable" #formElement>
    @if(arrayValid){
    <div class="toolbarForTable">
        <div class="buttonAndLabel">
            <label class="form-label fs-6 fw-bold text-gray-900" [ngClass]="{'hide': tableTitle.length === 0}">
                {{tableTitle}}
            </label>
            <div appClickedOutside (clickedOutside)="clickedOutside()">
                @if (columnsShow) {
                <antim-autoware-button leftIcon="view_column" type="button" label="Columns" btnType="primary"
                    (clickEvent)='hideShowColumn()'></antim-autoware-button>
                }
                @if(filterShow){
                <antim-autoware-button leftIcon="filter_alt" type="button" label="Filters" btnType="primary"
                    (clickEvent)='hideShowFilter()'></antim-autoware-button>
                }
                @if(sortShow){
                <antim-autoware-button leftIcon="swap_vert" type="button" label="Sort" btnType="primary"
                    (clickEvent)='hideShowSort()'></antim-autoware-button>
                }
                @if(exportShow){
                <antim-autoware-button leftIcon="download" type="button" label="Export" btnType="primary"
                    (clickEvent)='download()'></antim-autoware-button>
                }
                <span class="popup">
                    <span class="popuptext" [ngClass]="{'show': columnsPopupHideShow}">
                        <div class="popup-container">
                            @for (columnsOptionsItem of columnsOptions; track columnsOptionsItem; let i = $index) {
                            <antim-autoware-checkbox [id]="columnsOptionsItem.headerName"
                                [label]="columnsOptionsItem.headerName" [isChecked]="columnsOptionsItem.display"
                                (onInputChangeEvent)="columnsHideShow(i)" />
                            }
                        </div>
                        <button class="reset" [ngClass]="{'disabled': displayColumns.length === columns.length}"
                            [disabled]="displayColumns.length === columns.length" (click)="resetColumn()">
                            Reset
                        </button>
                    </span>
                    <span class="popuptext" [ngClass]="{'show': filterPopupHideShow}">
                        <div class="popup-container">
                            <form class="validate-form" [formGroup]="filterForm">
                                <antim-autoware-select id="columns" name="columns" inputType="primary"
                                    [control]="filterFormControls.columns" labelValue="Columns"
                                    [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                    placeholder="Please select filter field" labelFieldName="label"
                                    valueFieldName="value" [data]="filterOptions">
                                </antim-autoware-select>

                                <antim-autoware-select id="operator" name="operator" inputType="primary"
                                    [control]="filterFormControls.operator" labelValue="Operator"
                                    [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                    placeholder="Please select operator" labelFieldName="title" valueFieldName="value"
                                    [data]="operatorOptionsList">
                                </antim-autoware-select>

                                <antim-autoware-input [control]="filterFormControls.filterValue" type="text"
                                    id="filterValue" name="filterValue" labelValue="Filter Value"
                                    placeholder="Search"></antim-autoware-input>
                            </form>
                        </div>
                        <button class="reset" (click)="resetFilter()">
                            Reset
                        </button>
                    </span>
                    <span class="popuptext" [ngClass]="{'show': sortPopupHideShow}">
                        <div class="popup-container">
                            <form class="validate-form" [formGroup]="sortForm">
                                <antim-autoware-select id="columns" name="columns" inputType="primary"
                                    [control]="sortFormControls.columns" labelValue="Columns"
                                    [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                    placeholder="Please select sorting field" labelFieldName="label"
                                    valueFieldName="value" [data]="sortByOptions">
                                </antim-autoware-select>

                                <antim-autoware-select id="orderType" name="orderType" inputType="primary"
                                    [control]="sortFormControls.orderType" labelValue="Order Type"
                                    [mainElementStyle]="{'margin-bottom': '0.5rem !important'}"
                                    placeholder="Please select order type" labelFieldName="title" valueFieldName="value"
                                    [data]="sortOptionsList">
                                </antim-autoware-select>
                            </form>
                        </div>
                        <button class="reset" (click)="resetSort()">
                            Reset
                        </button>
                    </span>
                </span>
            </div>
        </div>
        <div>
            <input type="search" name="search" placeholder="Search" class="form-control search search-control"
                (input)="search($event)" />
        </div>
    </div>
    <div class="custom-table container-fluid">
        @if (currentRecords.length > 0){
        <div class="row">
            @for (currentRecordsItem of currentRecords; track currentRecordsItem;let index = $index) {
            <div class="zIndexZero" [ngClass]="responsiveClass">
                <antim-autoware-card [customCard]="'information-card'"
                    (click)="action(index, 'fa-solid fa-pen-to-square')">
                    @for (displayColumnsItem of displayColumns; track displayColumnsItem;let itemIndex = $index) {
                    <span>
                        @if (displayColumnsItem.field !== 'action' && displayColumnsItem.field !== 'isActive' &&
                        displayColumnsItem.field !== 'is_verified'){
                        <div class="{{displayColumnsItem.mobileClass}} {{displayColumnsItem.field}}">
                            <b class="field-title">{{displayColumnsItem.mobileHeaderName ||
                                displayColumnsItem.headerName}}</b>
                            @if (displayColumnsItem.type === 'radio'){
                            <antim-autoware-radio [data]="itemValueForRadio(currentRecordsItem, displayColumnsItem)"
                                [marginBottomZero]="true"
                                (onRadioChangeEvent)="onRadioChange(index, displayColumnsItem.field)" />
                            }
                            @else if (displayColumnsItem.type === 'checkbox'){
                            <antim-autoware-checkbox [id]="index.toString()"
                                [isChecked]="itemValueForCheckbox(currentRecordsItem, displayColumnsItem)"
                                [marginBottomZero]="true"
                                (onInputChangeEvent)="onCheckBoxChange(index, displayColumnsItem.field)" />
                            }
                            @else if (displayColumnsItem.type === 'image'){
                            <img [src]="itemValue(currentRecordsItem, displayColumnsItem, index)"
                                (error)="errorHandler($event)" />
                            }
                            @else if (displayColumnsItem.type === 'coverFile'){
                            <i class="fa-solid fa-file" (click)="file(index,'coverFile')"></i>
                            }
                            @else if (displayColumnsItem.type === 'resumeFile'){
                            <i class="fa-solid fa-file" (click)="file(index,'resumeFile')"></i>
                            }
                            @else if (displayColumnsItem.type === 'Select'){
                            <antim-autoware-select inputType="primary" [labelHide]="true" labelFieldName="label"
                                [value]="itemValue(currentRecordsItem, displayColumnsItem, index)"
                                valueFieldName="value" [data]="displayColumnsItem.data"
                                (change)="onSelectChange(index, $event)" />
                            }
                            @else if (displayColumnsItem.isTrueFalse){
                            <span
                                [ngClass]="{'active-status-mobile': currentRecordsItem[displayColumnsItem.field] === 1,
                                            'de-active-status-mobile': currentRecordsItem[displayColumnsItem.field] === 0}">
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                            }
                            @else if(displayColumnsItem.type === 'dateTime') {
                            {{dateTransformService.transFormDate(currentRecordsItem[displayColumnsItem.field])}}
                            }
                            @else {
                            <span>
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                            }
                            @if (displayColumnsItem.type === 'cleaner'){
                            <antim-autoware-select inputType="primary" [labelHide]="true" labelFieldName="label"
                                [value]="itemValue(currentRecordsItem, displayColumnsItem, index)"
                                valueFieldName="value" [data]="displayColumnsItem.data"
                                (change)="onCleanerChange(index, $event)" />
                            }
                        </div>
                        }
                        @else if(displayColumnsItem.field === 'is_verified'){
                        <div class="{{displayColumnsItem.mobileClass}} {{displayColumnsItem.field}}">
                            <b class="field-title">{{displayColumnsItem.mobileHeaderName ||
                                displayColumnsItem.headerName}}</b>
                            <span [ngClass]="{'pending-status-mobile': currentRecordsItem[displayColumnsItem.field] === 0,
                            'active-status-mobile': currentRecordsItem[displayColumnsItem.field] === 1,
                            'cancel-status-mobile': currentRecordsItem[displayColumnsItem.field] === 2}">
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                        </div>
                        }
                        @else if (displayColumnsItem.field === 'isActive') {
                        <div class="{{displayColumnsItem.mobileClass}} {{displayColumnsItem.field}}">
                            <b class="field-title">{{displayColumnsItem.mobileHeaderName ||
                                displayColumnsItem.headerName}}</b>
                            <span
                                [ngClass]="{'active-status-mobile': currentRecordsItem[displayColumnsItem.field] === true,
                                            'de-active-status-mobile': currentRecordsItem[displayColumnsItem.field] === false}">
                                {{itemValue(currentRecordsItem, displayColumnsItem, index)}}
                            </span>
                        </div>
                        }
                    </span>
                    }
                </antim-autoware-card>
                @for (displayColumnsItem of displayColumns; track displayColumnsItem; let itemIndex = $index) {
                <span>
                    @if (displayColumnsItem.field === 'action'){
                    <antim-autoware-card [customCard]="'action-card'">
                        @for (listItem of displayColumnsItem.list; track listItem) {
                        @if(listItem.conditionField === undefined ||
                        (
                        listItem.conditionField !== undefined &&
                        itemValueConditionCheck(currentRecordsItem,listItem)
                        )){
                        <i class="fa" [ngClass]="actionIcon(index, listItem.action)"
                            (click)="action(index, listItem.action)"
                            [title]="actionTitle(index, listItem.action, listItem.title)"></i>
                        }
                        }
                    </antim-autoware-card>
                    }
                </span>
                }
            </div>
            }
        </div>
        }
        @else {
        <div class="no-data-found">No Data Found</div>
        }
    </div>

    @if(paging){
    <div class="pagination">
        <div>
            Rows per page:
            <antim-autoware-select id="select" name="select" inputType="primary" [control]="pageSizeFormControl"
                [mainElementStyle]="{margin: '0px !important'}" [selectStyle]="{padding: '6px',marginLeft: '6px'}"
                placeholder="Please select page size" labelFieldName="title" valueFieldName="value"
                [data]="pageSizeList">
            </antim-autoware-select>
            <span class="details">
                {{startFrom}} - {{endTo}} of {{totalRecord}}
            </span>
        </div>

        @if (!(currentPage == totalPages && currentPage == 1)){
        <div>
            <span class="prevNext" (click)="onPageChange(1, 'prev')">
                <i class="fa-solid fa-chevron-left" [ngClass]="{'disabled': currentPage === 1}"></i>
            </span>
            <span class="prevNext" (click)="onPageChange(1, 'next')">
                <i class="fa-solid fa-chevron-right" [ngClass]="{'disabled': currentPage === totalPages}"></i>
            </span>
        </div>
        }
    </div>
    }
    }
    @else {
    <div class="no-data-found">Radio and checkbox column needed unique column name</div>
    }
</div>
}


<swal #deleteSwal title="Are you sure you want to delete?" iconHtml="<i class='fa-regular fa-trash-can'></i>"
    confirmButtonText="Yes" cancelButtonText="No" [showCancelButton]="true" [focusCancel]="true"
    (confirm)="confirmDelete()">
</swal>